var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRenewalDate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_195",
    "data-name": "Group 195",
    transform: "translate(-636 -626)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "date-outline-badged",
    transform: "translate(627.341 623.67)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_545",
    "data-name": "Path 545",
    d: "M24.342,35.273v7.653H11.571V32.892h1.368V31.98H11.457a.812.812,0,0,0-.8.826V43.013a.812.812,0,0,0,.8.826h13a.812.812,0,0,0,.8-.826V34.872A3.4,3.4,0,0,1,24.342,35.273Z",
    transform: "translate(0 -24.369)",
    fill: "#888"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_546",
    "data-name": "Path 546",
    d: "M42.64,74.62h.912v.912H42.64Z",
    transform: "translate(-29.245 -63.361)",
    fill: "#888"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_547",
    "data-name": "Path 547",
    d: "M74.62,74.62h.912v.912H74.62Z",
    transform: "translate(-58.488 -63.361)",
    fill: "#888"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_548",
    "data-name": "Path 548",
    d: "M106.6,74.62h.912v.912H106.6Z",
    transform: "translate(-87.731 -63.361)",
    fill: "#888"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_549",
    "data-name": "Path 549",
    d: "M138.58,74.62h.912v.912h-.912Z",
    transform: "translate(-116.975 -63.361)",
    fill: "#888"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_550",
    "data-name": "Path 550",
    d: "M42.64,101.27h.912v.912H42.64Z",
    transform: "translate(-29.245 -87.73)",
    fill: "#888"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_551",
    "data-name": "Path 551",
    d: "M74.62,101.27h.912v.912H74.62Z",
    transform: "translate(-58.488 -87.73)",
    fill: "#888"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_552",
    "data-name": "Path 552",
    d: "M106.6,101.27h.912v.912H106.6Z",
    transform: "translate(-87.731 -87.73)",
    fill: "#888"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_553",
    "data-name": "Path 553",
    d: "M138.58,101.27h.912v.912h-.912Z",
    transform: "translate(-116.975 -87.73)",
    fill: "#888"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_554",
    "data-name": "Path 554",
    d: "M42.64,127.92h.912v.912H42.64Z",
    transform: "translate(-29.245 -112.1)",
    fill: "#888"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_555",
    "data-name": "Path 555",
    d: "M74.62,127.92h.912v.912H74.62Z",
    transform: "translate(-58.488 -112.1)",
    fill: "#888"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_556",
    "data-name": "Path 556",
    d: "M106.6,127.92h.912v.912H106.6Z",
    transform: "translate(-87.731 -112.1)",
    fill: "#888"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_557",
    "data-name": "Path 557",
    d: "M138.58,127.92h.912v.912h-.912Z",
    transform: "translate(-116.975 -112.1)",
    fill: "#888"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_558",
    "data-name": "Path 558",
    d: "M48.426,14.309a.456.456,0,0,0,.456-.456V11.116a.456.456,0,0,0-.912,0v2.737A.456.456,0,0,0,48.426,14.309Z",
    transform: "translate(-34.119 -4.874)",
    fill: "#888"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_559",
    "data-name": "Path 559",
    d: "M73.623,31.98H69.29v.912h4.461A3.416,3.416,0,0,1,73.623,31.98Z",
    transform: "translate(-53.614 -24.369)",
    fill: "#888"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9",
    "data-name": "Ellipse 9",
    cx: 2.281,
    cy: 2.281,
    r: 2.281,
    transform: "translate(21.149 5.33)",
    fill: "#888"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_175",
    "data-name": "Rectangle 175",
    width: 20,
    height: 20,
    transform: "translate(636 626)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRenewalDate);
export default __webpack_public_path__ + "static/media/renewal-date.0a9a4fcbb12e7eb504f40dc830972a81.svg";
export { ForwardRef as ReactComponent };